import type { Track } from '@blackblack/shared';
import { api } from '../../lib/api';
import { useInfinite } from '../../lib/query';
import { useAuth } from '../../state/auth';
import { player } from '../../state/player';
import { Icon } from '../../components/ui/Icon';
import { Button, EmptyState, LoadMore } from '../../components/ui/primitives';
import { Page, PageHeader } from '../../components/layout';
import { navigate } from '../../lib/router';
import { TrackRow } from './TrackRow';
import { RowSkeleton } from './MusicPage';
import styles from './music.module.css';

export function LikedSongsPage() {
  const { me } = useAuth();
  const list = useInfinite<Track>(`liked-tracks:${me?.id}`, (cursor) => api.page<Track>('/music/liked', { cursor, limit: 50 }));

  return (
    <Page>
      <PageHeader title="Gelikete nummers" fallback="/music" />
      <div className={styles.collectionHero}>
        <span className={styles.likedArt}>
          <Icon name="heart" size={64} filled />
        </span>
        <h1>Gelikete nummers</h1>
        <p>{list.items.length} nummers</p>
        {list.items.length > 0 && (
          <div className={styles.collectionActions}>
            <Button icon="play" onClick={() => player.playTracks(list.items, 0, 'Gelikete nummers')}>
              Afspelen
            </Button>
          </div>
        )}
      </div>
      <div className={styles.rows}>
        {list.initialLoading && [0, 1, 2, 3].map((i) => <RowSkeleton key={i} />)}
        {!list.initialLoading && list.items.length === 0 && (
          <EmptyState icon="heart" title="Nog geen gelikete nummers" text="Tik op het hartje bij een nummer om het hier te bewaren." action={<Button onClick={() => navigate('/music')}>Muziek ontdekken</Button>} />
        )}
        {list.items.map((t, i) => (
          <TrackRow key={t.id} track={t} list={list.items} index={i} context="Gelikete nummers" />
        ))}
        <LoadMore onVisible={list.loadMore} loading={list.loading} hasMore={list.hasMore} />
      </div>
    </Page>
  );
}
